import React, { useEffect, useState, useContext, useCallback, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsChevronDown, BsPencil } from "react-icons/bs";
import hambuger from "../Images/hamburger-menu.svg";
import { BsFillFileEarmarkPersonFill, BsFillPersonFill, BsQuestionCircleFill, BsFillFileEarmarkTextFill } from "react-icons/bs";
import { MdSecurity, MdTopic, MdOutlineTopic, MdDocumentScanner } from "react-icons/md";
import { FaUsers, FaTasks, FaBook, FaBuilding } from "react-icons/fa";
import { PiUserFill, PiTextTFill } from "react-icons/pi";
import { AiFillFileText } from "react-icons/ai";
/* Commenting the following code for tenancyray.ray using AI Agent. 14/10/2026. Comment Start */
// import { BiFile, BiCalendarEvent, BiFolder, BiSolidBookContent, BiSolidBook, BiSolidFoodMenu, BiSolidFolder, BiSolidFolderOpen } from "react-icons/bi";
/* Commenting end. ray using AI Agent. 14/10/2026 */
/* Added the following code for tenancyray.ray using AI Agent. 14/10/2026. Code Start */
import { BiFile, BiCalendarEvent, BiFolder, BiSolidBookContent, BiSolidBook, BiSolidFoodMenu, BiSolidFolder } from "react-icons/bi";
/* Code end. ray using AI Agent. 14/10/2026 */
import { HiDocumentText } from "react-icons/hi";
import { HiMiniInformationCircle, HiClipboardDocumentList } from "react-icons/hi2";
import { LuFileSearch2 } from "react-icons/lu";
import { IoInformationCircle } from "react-icons/io5";
import { GrTemplate } from "react-icons/gr";
import { GiProcessor, GiRobotAntennas } from "react-icons/gi";
import { MenuPathContext } from "../context/MenuPathContext";
/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-09. Code Start */
import { CHAPTER_DEFAULT_SECTIONS } from "../chapterRootPages";
/* Commenting the following code for menu_active.ray using AI Agent. 20/08/2026. Comment Start */
// import menuSlugToCanonicalPath from "../menuSlugToCanonicalPath.json";
// import { toNavigableProgressPath } from "../pagePathUtils";
/* Commenting end. ray using AI Agent. 20/08/2026 */
/* Added the following code for caproj.ray using AI Agent. 14/09/2026. Code Start */
/* Capstone (and other leaves) may sit on short /canonical URLs while the sidebar
 * uses unique ch-* menu-slug paths — resolve before matching the highlight. */
import { toNavigableProgressPath } from "../pagePathUtils";
/* Code end. ray using AI Agent. 14/09/2026 */
/* Code end. ray using AI Agent. 2026-07-09 */
/* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
import SidebarProgress from "./SidebarProgress";
import {
  formatMissingChecklist,
  /* Added the following code for smarterresume.ray using AI Agent. 22/07/2026. Code Start */
  buildResumeNavState,
  /* Code end. ray using AI Agent. 22/07/2026 */
  /* Added the following code for FAST.Ray using AI Agent. 23/07/2026. Code Start */
  fetchLearningPath,
  /* Code end. Ray using AI Agent. 23/07/2026 */
} from "../progressApi";
/* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
import { useProgress } from "../context/ProgressContext";
/* Code end. Ray using AI Agent. 27/07/2026 */
import { toast } from "react-hot-toast";
import { hasPermission } from "../permissionUtils";
/* Code end. ray using AI Agent. 21/07/2026 */

/* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-19. Code Start */
/** Strips decorative emoji from menu labels (spreadsheet carryover). */
function stripMenuLabelEmojis(label) {
  if (!label || typeof label !== "string") return label;
  return label
    .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}
/* Code end. ray using AI Agent. 2026-06-19 */

/* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
/** After removing 1.2 Applications of NLP, show former 1.3/1.4 as 1.2/1.3. */
const CH1_SECTION_RENUMBER = {
  "1.3 The Five Eras of NLP": "1.2 The Five Eras of NLP",
  "1.4 The NLP Pipeline": "1.3 The NLP Pipeline",
  "The Five Eras of NLP": "1.2 The Five Eras of NLP",
  "The NLP Pipeline": "1.3 The NLP Pipeline",
};

function isRetiredCh12Node(node) {
  if (!node) return false;
  const s = String(node.slug || "").toLowerCase();
  const p = String(node.pageSlug || "").toLowerCase();
  const n = String(node.name || node.title || "").toLowerCase();
  return s.includes("12-applications-of-nlp") ||
         s.includes("1-2-applications-of-nlp") ||
         s.includes("1.2-applications-of-nlp") ||
         s.includes("applications-of-nlp") ||
         s.includes("boarder-applications-of-nlp") ||
         s.includes("broader-applications-of-nlp") ||
         n.includes("1.2 applications of nlp") ||
         n.includes("applications of nlp") ||
         n.includes("broader applications of nlp");
}
/* Code end. ray using AI Agent. 2026-08-24 */

/* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-09. Code Start */
function normalizeMenuTitle(title) {
  if (!title || typeof title !== "string") return title;
  return stripMenuLabelEmojis(title).replace(/\u2013/g, "-").trim();
}

function titlesMatch(a, b) {
  return normalizeMenuTitle(a) === normalizeMenuTitle(b);
}

/* Added the following code for progress.ray using AI Agent. 23/07/2026. Code Start */
/** True when a top-level (or folder) item is the learner Dashboard menu. */
function isDashboardMenuItem(item) {
  if (!item) return false;
  return (
    item.slug === "dashboard" ||
    item.path === "/home" ||
    titlesMatch(item.title, "Dashboard")
  );
}
/* Code end. ray using AI Agent. 23/07/2026 */

function findMenuPathIdByTitle(items, targetTitle, parentPathId = "") {
  if (!Array.isArray(items)) return null;

  for (let index = 0; index < items.length; index += 1) {
    const pathId = parentPathId ? `${parentPathId}-${index}` : `${index}`;
    if (titlesMatch(items[index].title, targetTitle)) return pathId;

    const childPathId = findMenuPathIdByTitle(items[index].submenuItems, targetTitle, pathId);
    if (childPathId) return childPathId;
  }

  return null;
}

function getAncestorPathIds(pathId) {
  const states = {};
  let current = pathId;

  while (current) {
    states[current] = true;
    const lastDash = current.lastIndexOf("-");
    if (lastDash === -1) break;
    current = current.slice(0, lastDash);
  }

  return states;
}

function findMenuItemByPath(items, targetPath, parentPathId = "") {
  if (!Array.isArray(items)) return null;

  for (let index = 0; index < items.length; index += 1) {
    const pathId = parentPathId ? `${parentPathId}-${index}` : `${index}`;
    const item = items[index];
    if (item.path === targetPath) {
      return { item, pathId };
    }

    const childMatch = findMenuItemByPath(item.submenuItems, targetPath, pathId);
    if (childMatch) return childMatch;
  }

  return null;
}

/* Commenting the following code for menu_active.ray using AI Agent. 20/08/2026. Comment Start */
// function normalizeMenuPathKey(value) { ... }
// function collectLocationMenuKeys(pathname) { ... }
// function itemMenuPathKeys(item) { ... }
// function findBestMenuItemForPath(items, pathname) { ... }
// function isMenuPathIdInTrail(pathId, selectedPathId) { ... }
/* Commenting end. ray using AI Agent. 20/08/2026 */

function buildChapterExpandStates(menus, chapterPath, sectionTitles = []) {
  const located = findMenuItemByPath(menus, chapterPath);
  if (!located) return {};

  const states = getAncestorPathIds(located.pathId);

  sectionTitles.forEach((sectionTitle) => {
    const sectionPathId = findMenuPathIdByTitle(
      located.item.submenuItems,
      sectionTitle,
      located.pathId
    );
    if (sectionPathId) {
      Object.assign(states, getAncestorPathIds(sectionPathId));
    }
  });

  return states;
}

function getChapterDefaultConfigForPath(pathname) {
  return Object.entries(CHAPTER_DEFAULT_SECTIONS).find(([, config]) =>
    config.contentPaths?.includes(pathname)
  );
}
/* Code end. ray using AI Agent. 2026-07-09 */

/**
 * Normalizes nav tree from API into the array shape expected by createMenu.
 * Supports the new array format and the legacy nested-object format.
 */
function normalizeTreeNodes(permissions) {
  if (Array.isArray(permissions)) {
    return permissions
      .filter((node) => !isRetiredCh12Node(node))
      .map((node) => ({
        ...node,
        children: normalizeTreeNodes(node.children || []),
      }));
  }
  if (!permissions || typeof permissions !== "object") return [];

  return Object.entries(permissions)
    .filter(([name]) => !isRetiredCh12Node({ name }))
    .map(([name, value]) => {
      const cleanName = stripMenuLabelEmojis(name);
      if (typeof value === "string") {
        return { name: cleanName, slug: value, isLeaf: true, children: [] };
      }
      if (Array.isArray(value)) {
        return { name: cleanName, slug: "", isLeaf: true, children: [] };
      }
      return {
        name: cleanName,
        slug: "",
        isLeaf: false,
        children: normalizeTreeNodes(value),
      };
    });
}

const SidebarSkeleton = () => (
  <ul className="pt-2 w-full px-2 animate-pulse">
    {Array.from({ length: 8 }).map((_, i) => (
      <li key={i} className="flex items-center gap-x-3 rounded-md mt-1 p-2">
        <div className="h-5 w-5 shrink-0 rounded bg-gray-200" />
        <div
          className="h-4 rounded bg-gray-200"
          style={{ width: `${55 + (i % 3) * 15}%` }}
        />
      </li>
    ))}
  </ul>
);

const Resside = ({ permissions, routePermits = [], loading = false }) => {
  const [Menus, setMenus] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  useContext(MenuPathContext);
  /* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
  // Progress / locks / view-as live in ProgressProvider (ProtectedLayout).
  const {
    progress,
    lockMap,
    progressStatus,
    progressError,
    viewAs,
    learnerPreview,
    isAdminUser,
    showProgressRail,
    isPathLocked,
    onResume,
    retryProgress,
    exitViewAs,
    exitLearnerPreview,
    registerMenus,
  } = useProgress();

  useEffect(() => {
    registerMenus(Menus);
  }, [Menus, registerMenus]);
  /* Code end. Ray using AI Agent. 27/07/2026 */

  /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
  const activeTenant = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("tenant")) || null;
    } catch {
      return null;
    }
  }, []);
  const isPlatformAdmin = localStorage.getItem("isPlatformAdmin") === "true";

  const getChapterRef = useCallback((menuItem) => {
    if (!menuItem) return null;
    const p = (menuItem.path || "").toLowerCase();
    const t = (menuItem.title || "").toLowerCase();
    const s = (menuItem.slug || "").toLowerCase();
    if (p.includes("/ch-1-") || s.includes("ch-1-") || t.startsWith("ch 1") || t.startsWith("1.")) return "ch1";
    if (p.includes("/ch-2-") || s.includes("ch-2-") || t.startsWith("ch 2") || t.startsWith("2.")) return "ch2";
    if (p.includes("/ch-3-") || s.includes("ch-3-") || t.startsWith("ch 3") || t.startsWith("3.")) return "ch3";
    if (p.includes("/ch-4-") || s.includes("ch-4-") || t.startsWith("ch 4") || t.startsWith("4.")) return "ch4";
    if (p.includes("/ch-5-") || s.includes("ch-5-") || t.startsWith("ch 5") || t.startsWith("5.")) return "ch5";
    if (p.includes("/ch-6-") || s.includes("ch-6-") || t.startsWith("ch 6") || t.startsWith("6.")) return "ch6";
    if (p.includes("/ch-7-") || s.includes("ch-7-") || t.startsWith("ch 7") || t.startsWith("7.")) return "ch7";
    return null;
  }, []);
  /* Code end. ray using AI Agent. Oct 9, 2026 */

  const Icons_Routes_Object = React.useMemo(() => ({
    "Dashboard": [<BiSolidBookContent />, "/home"],
    "Security": [<MdSecurity />],
    "Users": [<FaUsers />, "/users"],
    "Roles": [<PiUserFill />, "/roles"],
    "ParseHRDocs": [<HiDocumentText />],
    "Job Parser": [<BsFillFileEarmarkPersonFill />, "/hr-parser"],
    "Resume Parser": [<BiFile />, "/resume-parser"],
    "Resume Job Matcher": [<FaBook />, "/resume-job-matcher"],
    "ParseSCMDocs": [<BiSolidFolder />],
    "RFx Parse": [<MdDocumentScanner />, "/scm-parser/rfx-parser"],
    "RFx Scope-Company Capabilities Matcher": [<HiClipboardDocumentList />, "/scm-parser/rfx-scope-company-capabilities-matcher"],
    "NLP Foundational Knowledge": [<GiProcessor />, "/ch-1-foundation-years-1950s-2010s"],
    "Ch 1: Foundation Years (1950s–2010s)": [<GiProcessor />, "/ch-1-foundation-years-1950s-2010s"],
  /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-07. Code Start */
    "Ch 1: Foundation Years (1950s-2010s)": [<GiProcessor />, "/ch-1-foundation-years-1950s-2010s"],
    "Ch 2: Pre-Transformer DL (2012-2017)": [<GiProcessor />, "/ch-2-pre-transformer-dl-2012-2017"],
    "Ch 3: Transformer Revolution (2017-2018)": [<GiProcessor />, "/ch-3-transformer-revolution-2017-2018"],
    "Ch 4: Age of LLMs (2019-Present)": [<GiProcessor />, "/ch-4-age-of-llms-2019-present"],
    "Ch 5: Working with LLMs": [<GiProcessor />, "/ch-5-working-with-llms"],
    "Ch 6: Model Improvement, Explainability & Safety": [<GiProcessor />, "/ch-6-model-improvement-explainability-safety"],
    "Ch 7: Real-World Applications": [<GiProcessor />, "/ch-7-real-world-applications"],
  /* Code end. ray using AI Agent. 2026-07-07 */
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    "1.1 What is NLP?": [<BiSolidFolder />],
    "What is NLP?": [<BiSolidFolder />],
    /* Code end. ray using AI Agent. 2026-07-10 */
    /* Commenting the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Comment Start */
    // "1.1 What is NLP?": [<BiSolidBook />, "/ch-1-foundation-years-1950s-2010s"],
    // "What is NLP?": [<BiSolidBook />, "/ch-1-foundation-years-1950s-2010s"],
    /* Commenting end. ray using AI Agent. 2026-07-10 */
    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
    // "1.2 Applications of NLP": [<BiSolidFolder />],
    /* Commenting end. ray using AI Agent. 2026-08-24 */
    /* Code end. ray using AI Agent. 2026-07-10 */
    /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
    // "Overview + pointers to Ch 7": [<BiSolidBook />, "/overview-pointers-to-ch-7"],
    /* Commenting end. ray using AI Agent. 2026-08-24 */
    /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
    // "1.3 The Five Eras of NLP": [<BiSolidFolder />],
    // "1.4 The NLP Pipeline": [<HiDocumentText />, "/nlp-pipeline"],
    /* Commenting end. ray using AI Agent. 2026-08-24 */
    /* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
    "1.2 The Five Eras of NLP": [<BiSolidFolder />],
    "1.3 The NLP Pipeline": [<HiDocumentText />, "/nlp-pipeline"],
    /* Code end. ray using AI Agent. 2026-08-24 */
    "Era 1: Rule-Based (1950s–1990s)": [<BiSolidFolder />],
    "Era 2: Statistical NLP (1990s–2000s)": [<BiSolidFolder />],
    "Era 3: ML Takes Over (2000s–2010s)": [<BiSolidFolder />],
    "Era 4: Neural Revolution (2010–2017)": [<BiSolidFolder />],
    "Era 5: Transformer Breakthrough (2017–2018)": [<BiSolidFolder />],
    "What is NLP": [<BiSolidBook />, "/whatis-NLP"],
    "Language Modeling (NLP)": [<BiSolidBook />, "/language-modeling-nlp"],
    "Broader Tasks of NLP": [<BiSolidFolder />, "broader-tasks-of-nlp"],
    "Trending Topic Detection": [<BiSolidBook />, "/trending-topic-detection"],
    "Rule-Based Systems": [<BiSolidBook />, "/rule-based"],
    "REGular EXpressions (REGEX)": [<BiSolidBook />, "/regular-expression"],
    "TokensREGEX": [<BiSolidBook />, "/tokens-REGEX"],
    "Pragex": [<BiSolidBook />, "/pragex"],
    "Supervised Learning": [<BiSolidBook />, "/supervised"],
    "Unsupervised Learning": [<BiSolidBook />, "/unsupervised"],
    "Semi-Supervised Learning": [<BiSolidBook />, "/semisupervised"],
    "Reinforced Learning": [<BiSolidBook />, "/reinforced"],
    "Naive Bayes": [<BiSolidBook />, "/naive-bayes"],
    "Support Vector Machine (SVM)": [<BiSolidBook />, "/support-vector"],
    "Hidden Markov Model (HMM)": [<BiSolidBook />, "/HMM-nlp"],
    "Conditional Random Fields (CRF)": [<BiSolidBook />, "/CRF"],
    "Recurrent Neural Network (RNN)": [<BiSolidBook />, "/recurrent-neural-networks"],
    "Long Short-Term Memory (LSTM)": [<BiSolidBook />, "/lsterm-memory"],
    "Gated Recurrent Units": [<BiSolidBook />, "/gated-recurrent-units"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-24. Code Start */
    "Attention / Self-Attention Mechanism": [<BiSolidBook />, "/attention-mechanism"],
    /* Code end. ray using AI Agent. 2026-06-24 */
    "Multi-head Attention": [<BiSolidBook />, "multi-head-attention"],
    "Feedforward Network": [<BiSolidBook />, "feedforward-network"],
    "Positional Encoding": [<BiSolidBook />, "positional-encoding"],
    "Add & Norm": [<BiSolidBook />, "/add-norm"],
    "Masked Head Attention": [<BiSolidBook />, "/masked-head-attention"],
    "Auto-Encoders": [<BiSolidFolder />, "/auto-encoders"],
    "Architecture": [<BiSolidBook />, "/auto-encoder-architecture"],
    "Opinion Mining": [<BiSolidBook />, "/opinion-mining"],
    "Sentiment Detection": [<BiSolidBook />, "/sentiment-detection"],
    "Rumor/Fake News Detection": [<BiSolidBook />, "/fakenews-detection"],
    "Customer Support": [<BiSolidBook />, "/customer-support"],
    "Catalog Review Analysis": [<BiSolidBook />, "/catalog-review-analysis"],
    "Product Search": [<BiSolidBook />, "/product-search"],
    "Product Recommendations": [<BiSolidBook />, "/product-recommendations"],
    "Health Care": [<BiSolidBook />, "/health-care"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Health Care (Pre-LLM)": [<BiSolidBook />, "/health-care"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Finance (Pre-LLM)": [<BiSolidBook />, "/finance-pre-llm"],
    "Law (Pre-LLM)": [<BiSolidBook />, "/law-pre-llm"],
    "Un-Supervised Learning": [<BiSolidBook />, "/unsupervised"],
    "Rule Based Systems": [<BiSolidBook />, "/rule-based"],
    "Regular Expressions": [<BiSolidBook />, "/regular-expression"],
    "Support Vector Machine": [<BiSolidBook />, "/support-vector"],
    "Hidden Markov Model": [<BiSolidBook />, "/HMM-nlp"],
    "Conditional Random Fields": [<BiSolidBook />, "/CRF"],
    "Convolutional Neural Networks": [<BiSolidBook />, "/convolutional-neural-networks"],
    "Configurations": [<BiSolidBook />, "/configurations"],
    "Next Sentence Prediction (NSP)": [<BiSolidBook />, "/next-sentence-prediction"],
    "Pre-training and Fine-tuning": [<BiSolidBook />, "/pre-training-and-fine-tuning"],
    "Token Embedding": [<BiSolidBook />, "/token-embedding"],
    "Segment Embedding": [<BiSolidBook />, "/segment-embedding"],
    "Position Embedding (BERT)": [<BiSolidBook />, "/position-embedding-bert"],
    "Language Modeling in BERT": [<BiSolidBook />, "/language-modeling-bert"],
    "Masked-Language-Modeling": [<BiSolidBook />, "/masked-language"],
    "Distillation": [<BiSolidBook />, "/distillation"],
    "Pruning": [<BiSolidBook />, "/pruning"],
    "Quantization": [<BiSolidBook />, "/quantization"],
    "Out-of-Domain Generalization and Model Evaluation": [<BiSolidBook />, "/out-of-domain"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Out-of-Domain Generalization": [<BiSolidBook />, "/out-of-domain"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Fine Tuning and Sample Efficiency": [<BiSolidBook />, "/fine-tuning-sample-efficiency"],
    "Common Sense and Inductive Bias": [<FaBook />, "/common-sense"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Common Sense & Inductive Bias": [<FaBook />, "/common-sense"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    /* Added the following code for ch6impl.ray using AI Agent. 08/09/2026. Code Start */
    "Understanding Hallucinations": [<BiSolidBook />, "/understanding-hallucinations"],
    "Hallucination Detection": [<BiSolidBook />, "/hallucination-detection"],
    "Retrieval-Augmented Generation (RAG)": [<BiSolidBook />, "/rag-grounding"],
    "Knowledge Grounding Techniques": [<BiSolidBook />, "/knowledge-grounding"],
    "Training-Time Mitigation": [<BiSolidBook />, "/training-time-mitigation"],
    "Inference-Time Mitigation": [<BiSolidBook />, "/inference-time-mitigation"],
    "Sources of Bias in LLMs": [<BiSolidBook />, "/sources-of-bias"],
    "Types of Harmful Outputs": [<BiSolidBook />, "/harmful-outputs"],
    "Fairness Evaluation": [<BiSolidBook />, "/fairness-evaluation"],
    "Bias Mitigation Strategies": [<BiSolidBook />, "/bias-mitigation"],
    "Responsible AI Frameworks": [<BiSolidBook />, "/responsible-ai-frameworks"],
    "Dual-Use & Misuse Concerns": [<BiSolidBook />, "/dual-use-misuse"],
    "Multimodal LLMs": [<BiSolidBook />, "/multimodal-llms"],
    "Long-Context & Efficient Models": [<BiSolidBook />, "/long-context-efficient"],
    "LLM-based Agents": [<BiSolidBook />, "/llm-agents"],
    "Reasoning Advancements": [<BiSolidBook />, "/reasoning-advancements"],
    "Alignment & Safety Research": [<BiSolidBook />, "/alignment-safety-research"],
    "Toward AGI": [<BiSolidBook />, "/toward-agi"],
    /* Code end. ray using AI Agent. 08/09/2026 */
    "NLP Pipeline": [<HiDocumentText />, "/nlp-pipeline"],
    "Data Acquisition": [<BsFillFileEarmarkPersonFill />, "/data-acquisition"],
    "Text Cleaning": [<BiFile />, "/text-cleaning"],
    "Pre-Processing": [<FaBook />, "/pre-processing"],
    "One-Hot Encoding": [<FaBook />, "/one-hot-encoding"],
    "Bag of Words": [<FaBook />, "/bag-of-words"],
    "Bag of N-Grams (BoN)": [<FaBook />, "/bag-of-ngrams"],
    "TF-IDF": [<FaBook />, "/tf-idf"],
    "Distributional & Distributed Representation": [<FaBook />, "/distributional-distributed-representation"],
    "Universal Language Representation": [<FaBook />, "/universal-language-representation"],
    "Hand Crafted Features": [<FaBook />, "/hand-crafted-features"],
    "Modeling": [<FaBook />, "/modeling"],
    "Evaluation": [<FaBook />, "/evaluation"],
    "Deployment & Monitoring": [<FaBook />, "/deployment-monitoring"],
    "Model Updating": [<FaBook />, "/model-updating"],
    "Explainable AI": [<BiSolidFolder />],
    "SHAP": [<MdDocumentScanner />, "/shap"],
    "LIME": [<HiClipboardDocumentList />, "/lime"],
    "Large Language Models (LLMs)": [<HiDocumentText />, "/llm-main-submenu"],
    "All About LLMs": [<BiFolder />, "all-about-llms"],
    "Introduction": [<FaBook />, "/introduction"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "All About LLMs → Introduction": [<FaBook />, "/introduction"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "History of LLMs": [<BiFolder />, "history-of-llms"],
    "Statistical Language Models": [<FaBook />, "/statistical-language-models"],
    "Neural Language Modeling": [<FaBook />, "/neural-language-modeling"],
    "Pre-trained Language Models": [<FaBook />, "/pre-trained-language-models"],
    "Large Language Models": [<FaBook />, "/large-language-models"],
    "Emerging Abilities of LLMs": [<FaBook />, "/emerging-abilities-of-llms"],
    "Success Factors of LLMs": [<BiFolder />, "success-factors-of-llms"],
    "Scaling Laws": [<FaBook />, "/scaling-laws"],
    "Training": [<FaBook />, "/training"],
    "Ability Eliciting": [<FaBook />, "/ability-elicting"],
    "Alignment Tuning (SF-LLM)": [<FaBook />, "/alignment-tuning-sf-llm"],
    "LLM Resources": [<BiFolder />, "llm-resources"],
    "Open Source LLMs": [<BiFolder />, "open-source-llms"],
    "Publicly Available Model Check Points": [<FaBook />, "/publicly-available-model-check-points"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Publicly Available Checkpoints": [<FaBook />, "/publicly-available-model-check-points"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Smaller Models (10s of Billion Parameters)": [<FaBook />, "/smaller-models-tens-of-billion-parameters"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Smaller Models (10s B)": [<FaBook />, "/smaller-models-tens-of-billion-parameters"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Larger Models (100s of Billion Parameters)": [<FaBook />, "/larger-models-hundereds-of-billion-parameters"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Larger Models (100s B)": [<FaBook />, "/larger-models-hundereds-of-billion-parameters"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "LLaMA Model Family": [<FaBook />, "/llama-model-family"],
    "Closed Source LLMs": [<BiFile />, "/closed-source-llms"],
    "Corpora for Pre-training": [<BiFile />, "corpora-for-pre-training"],
    "Datasets for Fine-Tuning": [<BiFolder />, "datasets-for-finetuning"],
    "Instruction Tuning Datasets": [<FaBook />, "/instruction-tuning-datasets"],
    "Alignment Tuning Datasets": [<FaBook />, "/alignment-tuning-datasets"],
    "Dailychat Datasets": [<FaBook />, "/dailychat-tuning-datasets"],
    "Synthetic Datasets": [<FaBook />, "/synthetic-tuning-datasets"],
    "Resources for LLM Development": [<BiFolder />, "resources-for-llm-developments"],
    "Transformer": [<FaBook />, "/transformer"],
    "DeepSpeed": [<FaBook />, "/deepspeed"],
    "MegaTron": [<FaBook />, "/megatron"],
    "Jax": [<FaBook />, "/jax"],
    "Colossal-AI": [<FaBook />, "/colossal-ai"],
    "BMTrain": [<FaBook />, "/bmtrain"],
    "FastMoE": [<FaBook />, "/fastmoe"],
    "vLLM": [<FaBook />, "/vllm"],
    "DeepSpeed-MIT": [<FaBook />, "/deepspeed-mit"],
    "DeepSpeed-Chat": [<FaBook />, "/deepspeed-chat"],
    "Additional Resources": [<FaBook />, "/additional-resources"],
    "Pre-Training Pipeline": [<BiFolder />, "pre-training-pipeline"],
    "Data Collection and Preparation": [<FaBook />, "/data-collection-and-preparation"],
    "Data Pre-Processing": [<FaBook />, "/data-pre-processing"],
    "Data Source": [<FaBook />, "/data-source"],
    "Data Scheduling": [<FaBook />, "/data-scheduling"],
    "Architecture Considerations for Pre-Training": [<FaBook />, "/architecture-considerations-for-pre-training"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Architecture Considerations": [<FaBook />, "/architecture-considerations-for-pre-training"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Configuration Considerations for Pre-Training": [<BiFolder />, "/configuration-considerations-pretraining"],
    "Normalization Methods": [<FaBook />, "/normalization-methods"],
    "Normalization Position": [<FaBook />, "/normalization-position"],
    "Activation Functions": [<FaBook />, "/activation-functions"],
    "Position Embedding (LLM)": [<FaBook />, "/position-embedding-llm"],
    "Attention": [<FaBook />, "/attention"],
    "Pre-Training Tasks": [<BiFolder />, "pre-training-tasks"],
    "Language Modeling (PTT)": [<FaBook />, "/language-modeling-ptt"],
    "Denoising Auto-Encoding": [<FaBook />, "/denoising-auto-encoding"],
    "Mixture of Denoisers": [<FaBook />, "/mixture-of-denoiser"],
    "Long-context Modeling": [<BiFolder />, "long-context-modeling"],
    "Scaling Position Embedding": [<FaBook />, "/scaling-position-embedding"],
    "Adapting Context Window": [<FaBook />, "/adapting-context-window"],
    "Model Training Considerations": [<BiFolder />, "/model-training"],
    "Optimization Setting": [<FaBook />, "/optimization-setting"],
    "Scalable Training Settings": [<FaBook />, "/scalable-training-settings"],
    "ZERO": [<FaBook />, "/zero"],
    "Mixed Precision Training": [<FaBook />, "/mixed-precision-training"],
    "Fine-Tuning LLMs": [<BiFolder />, "finetuning-llms"],
    "Instruction Tuning": [<FaBook />, "/instruction-tuning"],
    "Alignment Tuning (FT-LLM)": [<FaBook />, "/alignment-tuning-ft-llm"],
    "Parameter Tuning": [<FaBook />, "/parameter-tuning"],
    "Memory Tuning": [<FaBook />, "/memory-tuning"],
    "Model Evaluation": [<BiFolder />, "model-evaluation"],
    "Evaluating Basic Abilities": [<BiFolder />, "basic-abilities"],
    "Language Generation": [<BiFolder />, "language-generation"],
    "Language Modeling (LG)": [<FaBook />, "/language-modeling-lg"],
    "Conditional Text Generation": [<FaBook />, "/conditional-text-generation"],
    "Code Synthesis Tasks": [<FaBook />, "/code-synthesis-tasks"],
    "Knowledge Utilization": [<BiFolder />, "knowledge-utilization"],
    "Closed-book QA": [<FaBook />, "/closed-book-qa"],
    "Open-book QA": [<FaBook />, "/open-book-qa"],
    "Knowledge Completion": [<FaBook />, "/knowledge-completion"],
    "Complex Reasoning": [<FaBook />, "/complex-reasoning"],
    "Evaluating Advanced Abilities": [<BiFolder />, "advance-abilities"],
    "Human Alignment": [<FaBook />, "/human-alignment"],
    "Interaction with External Environment": [<FaBook />, "/interaction-with-external-enviournment"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "External Environment": [<FaBook />, "/interaction-with-external-enviournment"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Tool Manipulation": [<FaBook />, "/tool-manipulation"],
    "Benchmark and Evaluation Approaches": [<BiFolder />, "/benchmark-evaluation"],
    "Benchmark-based evaluation metrics": [<FaBook />, "/benchmark-based-evaluation-metrics"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Benchmark-based metrics": [<FaBook />, "/benchmark-based-evaluation-metrics"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Human-based evaluation metrics": [<FaBook />, "/human-based-evaluation-metrics"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Human-based metrics": [<FaBook />, "/human-based-evaluation-metrics"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Model-based evaluation metrics": [<FaBook />, "/model-based-evaluation-metrics"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Model-based metrics": [<FaBook />, "/model-based-evaluation-metrics"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Applications of LLMs": [<BiFolder />, "/applications-of-llms"],
    "LLM Improvement Research Areas": [<BiFolder />, "/llM-improvement-Research-Areas"],
    "Classic NLP Areas": [<BiFolder />, "classic-nlptasks"],
    "NLP Tasks": [<BiFolder />, "/nlp-tasks"],
    "Word/Sentence-level Tasks": [<FaBook />, "/word-sentence-level-tasks"],
    "Sequence Tagging": [<FaBook />, "/sequence-tagging"],
    "Information Extraction": [<FaBook />, "/information-extraction"],
    "Text Generation": [<FaBook />, "/text-generation"],
    "LLM for Information Retrieval (IR)": [<BiFolder />, "llm-for-ir"],
    "LLM as IR Model": [<FaBook />, "/llm-as-ir-model"],
    "LLM-enhanced IR-Models": [<FaBook />, "/llm-enhanced-ir-models"],
    "LLM for Recommenders": [<BiFolder />, "/llm-for-recommenders"],
    "LLM as Recommendation Model": [<FaBook />, "/llm-as-recommendation-model"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "LLM as Rec Model": [<FaBook />, "/llm-as-recommendation-model"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "LLM-enhanced Recommendation Models": [<FaBook />, "/llm-enhanced-recommendation-models"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "LLM-enhanced Rec": [<FaBook />, "/llm-enhanced-recommendation-models"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "LLM as Recommendation Simulator": [<FaBook />, "/llm-as-recommendation-simulator"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "LLM as Rec Simulator": [<FaBook />, "/llm-as-recommendation-simulator"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Enhancing LLMs": [<BiFolder />, "/enhancing-llms"],
    "Multi-modal LLMs": [<BiFolder />, "/multi-modal-llms"],
    "Vision-Language Alignment Pre-Training": [<FaBook />, "/vision-language-alignment"],
    "Visual Instruction Tuning": [<FaBook />, "/visual-instruction-tuning"],
    "Evaluation of MLLM": [<FaBook />, "/evaluation-of-MLLM"],
    "Knowledge Graph Enhanced LLM": [<BiFolder />, "/knowledge-graph-enhanced-llm"],
    "KG Enhanced LLM": [<BiFolder />, "/knowledge-graph-enhanced-llm"],
    "5.3 RAG": [<BiFolder />],
    "RAG": [<BiFolder />],
    "Retrieval-Augmented LLM": [<FaBook />, "/retrieval-augmented-llm"],
    "Synergy Augmented LLM": [<FaBook />, "/synergy-augmented-LLM"],
    "New Capabilities": [<BiFolder />, "/new-capabilities"],
    "LLM-based Agent": [<BiFolder />, "/llm-based-agent"],
    "Components: Memory/Planning/Execution": [<FaBook />, "/llm-agent-components"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Memory/Planning/Execution": [<FaBook />, "/llm-agent-components"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Single/Multi-agent based Application": [<FaBook />, "/llm-multi-agent-apps"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Single/Multi-agent Apps": [<FaBook />, "/llm-multi-agent-apps"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "LLM for Evaluation": [<BiFolder />, "/llm-for-evaluation"],
    "Score/Language-based Evaluation": [<FaBook />, "/score-language-evaluation"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Score/Language-based": [<FaBook />, "/score-language-evaluation"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Instruction Design, Multiple Feedbacks, Debate Agent": [<FaBook />, "/instruction-design-feedback"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Instruction Design": [<FaBook />, "/instruction-design-feedback"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Meta-Evaluation": [<FaBook />, "/meta-evaluation"],
    "Domain Applications": [<BiFolder />, "/domain-applications"],
    "Healthcare": [<FaBook />, "/healthcare"],
    "Finance (Post-LLM)": [<FaBook />, "/finance-post-llm"],
    "Scientific Research": [<FaBook />, "/scientific-research"],
    "Law (Post-LLM)": [<FaBook />, "/law-post-llm"],
    "Education": [<FaBook />, "/education"],
    "Background of LLMs": [<FaBook />, "/background-of-llms"],
    "Resources for Pre-Training LLMs": [<FaBook />, "/resources-for-pre-training-llms"],
    "Pre-Training of LLMs": [<FaBook />, "/pre-training-for-llms"],
    "Fine-Tuning of LLMs": [<FaBook />, "/fine-tuning-for-llms"],
    "Capability and Evaluation of LLMs": [<FaBook />, "/capacity-and-evaluation-of-llms"],
    "Instructions Tuning Datasets": [<FaBook />, "/instructions-tuning-datasets"],
    /* Commenting the following code for smarterresume.ray using AI Agent. 22/07/2026. Comment Start */
    // Removed duplicate Icons_Routes key for Synthetic Datasets (same path as the earlier entry).
    /* Commenting end. ray using AI Agent. 22/07/2026 */
    "Capacity and Evaluation of LLMs": [<FaBook />, "/capacity-and-evaluation-of-llms"],
    "Agents": [<HiDocumentText />, "/agents"],
    "Agents Structure Setup": [<FaBook />, "/agents-structure-setup"],
    "Agents List": [<FaBook />, "/agents-list"],
    "Masked Language Modeling (MLM)": [<BiSolidFoodMenu />, "/masked-language"],
    "Prompt Engineering": [<BsPencil />, "/prompting-main-submenu"],
    "Introduction & Structure": [<BiFolder />, "introduction-structure"],
    "TOCD": [<BiSolidBook />, "/tocd"],
    "RTAO": [<BiSolidBook />, "/rtao"],
    "Ultimate Structure": [<BiSolidBook />, "/ultimate-structure"],
    "Methods of Prompting": [<BiFolder />, "methods-of-prompting"],
    "Core Prompting": [<BiFolder />, "core-prompting"],
    "Role-Playing Prompting": [<BiSolidBook />, "role-playing-promptings"],
    "Role-based Prompting": [<BiSolidBook />, "/role-based-prompting"],
    "Persona-based Prompting": [<BiSolidBook />, "/persona-based-prompting"],
    "Scenario-based Prompting": [<BiSolidBook />, "/scenario-based-prompting"],
    "N-Shot Prompting": [<BiSolidBook />, "n-shot-promptings"],
    "Zero-shot Prompting": [<BiSolidBook />, "/zero-shot-prompting"],
    "One-shot Prompting": [<BiSolidBook />, "/one-shot-prompting"],
    "Few-shot Prompting": [<BiSolidBook />, "/few-shot-prompting"],
    "Role-Reversal Prompting": [<BiSolidBook />, "/role-reversal-promptings"],
    "Context-Based Prompting": [<BiSolidBook />, "/context-based-prompting"],
    "Advanced Prompting": [<BiFolder />, "advanced-prompting"],
    "Output-driven Prompting": [<BiSolidBook />, "/output-driven-prompting"],
    "LLM-Assisted Prompting": [<BiSolidBook />, "/llm-assisted-prompting"],
    "Decomposed Prompting": [<BiSolidBook />, "/decomposed-prompting"],
    "Prompt Chaining": [<BiSolidBook />, "/prompt-chaining"],
    "Hierarchical Prompting": [<BiSolidBook />, "/hierarchical-prompting"],
    "Chain-of-Thought Prompting": [<BiSolidBook />, "/chain-of-thought-prompting"],
    "Hallucination-mitigation Prompting": [<BiSolidBook />, "/hallucination-mitigation-prompting"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Hallucination-mitigation": [<BiSolidBook />, "/hallucination-mitigation-prompting"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Expert Prompting": [<BiFolder />, "expert-prompting"],
    "Tree-of-Thought Prompting": [<BiSolidBook />, "/tree-of-thought-prompting"],
    "Chain-of-Verification Prompting": [<BiSolidBook />, "/chain-of-verification-prompting"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Chain-of-Verification": [<BiSolidBook />, "/chain-of-verification-prompting"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Ensemble Prompting": [<BiSolidBook />, "/ensemble-prompting"],
    "Debiasing Prompting": [<BiSolidBook />, "/debiasing-prompting"],
    "Prompt-Attack-Defence Prompting": [<BiSolidBook />, "/prompt-attack-defence-prompting"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Prompt-Attack-Defence": [<BiSolidBook />, "/prompt-attack-defence-prompting"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "NLP Implementations": [<GiProcessor />, "/nlp-implementations"],
    "Keyphrase Extraction": [<BiSolidBook />, "/keyphrase-extraction"],
    "Named Entity Recognition (NER)": [<BiSolidBookContent />, "/entity-recognition"],
    "Named Entity Disambiguation and Linking": [<BiFolder />, "/named-entity-disambiguation"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Entity Disambiguation & Linking": [<BiFolder />, "/named-entity-disambiguation"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Relation Extraction": [<BiSolidFoodMenu />, "/relation-extraction"],
    "Advanced IE Tasks": [<FaTasks />],
    "Temporal Information Extraction": [<IoInformationCircle />, "/temporal-information"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Temporal Info Extraction": [<IoInformationCircle />, "/temporal-information"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Event Extraction": [<BiCalendarEvent />, "/event-extraction"],
    "Template Filling": [<GrTemplate />, "/template-filling"],
    "Document Matcher": [<AiFillFileText />, "/doc-matcher"],
    "Topic Matcher": [<MdTopic />, "/topic-entries"],
    "Search and Information Retrieval": [<GrTemplate />, "/search-and-information-retrieval"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Search and IR": [<GrTemplate />, "/search-and-information-retrieval"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Recommender Systems for Textual Data": [<GrTemplate />, "/recommender-systems-for-textual-data"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Recommender Systems": [<GrTemplate />, "/recommender-systems-for-textual-data"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Question and Answering Systems": [<GrTemplate />, "/question-and-answering-systems"],
    /* Added the following code for ray_menustructure.ray using AI Agent. 24 Jun 2026. Code Start */
    "Q&A Systems": [<GrTemplate />, "/question-and-answering-systems"],
    /* Code end. ray using AI Agent. 24 Jun 2026 */
    "Chatbot Systems": [<GrTemplate />, "/chatbot-systems"],
    "Machine Translation": [<GrTemplate />, "/machine-translation"],
    "Latent Dirichlet Allocation (LDA)": [<GrTemplate />, "Latent-dirichlet-allocation"],
    "Latent Semantic Analysis (LSA)": [<GrTemplate />, "Latent-semantic-analysis"],
    "Probabilistic Latent Semantic Analysis (PLSA)": [<GrTemplate />, "probabilistic-latent-semantic-analysis"],
    "Binary Classification": [<GrTemplate />, "/binary-classification"],
    "Multi-Class Classification": [<GrTemplate />, "/multi-class-classification"],
    "Multi-label Classification": [<GrTemplate />, "/multi-label-classification"],
    "Extractive Summarization": [<GrTemplate />, "/extractive-summarization"],
    "Abstractive Summarization": [<GrTemplate />, "/abstractive-summarization"],
    "Question Answering Systems": [<BsQuestionCircleFill />],
    "Q&A Bot": [<BsFillPersonFill />, "/qandAbot"],
    "Industry Applications of NLP": [<FaTasks />, "/industry-applications-of-nlp"],
    "Social Media": [<FaBook />, "/social-media"],
    "Ecommerce & Retail": [<FaBook />, "/ecommerce-retail"],
    "Approaches to NLP": [<FaTasks />, "/approaches-to-NLP"],
    "Heuristics-based": [<BsFillPersonFill />, "/heuristic-based"],
    "Types": [<BiSolidBookContent />, "/types"],
    "Methods": [<BiSolidBookContent />, "/methods"],
    "Machine Learning-based NLP": [<MdDocumentScanner />, "/mlbased-NLP"],
    "Deep Learning-based NLP": [<BiSolidFoodMenu />, "/dlbased-NLP"],
    "Neural Networks": [<BiSolidBook />, "/neural-networks"],
    "Transformers": [<HiClipboardDocumentList />, "/transformers"],
    "Exploring Pre-LLMs (BERT)": [<GiRobotAntennas />, "/exploring-BERT"],
    "Input Data Preparation": [<BiFolder />, "/input-data-preparation"],
    "Model Improvement Techniques": [<FaTasks />, "/model-improvement-techniques"],
    "Model Size Reduction": [<FaBook />, "/model-size-reduction"],
    "Feature Engineering": [<FaBook />, "/feature-engineering"],
    "Basic Vectorization Approaches": [<FaBook />, "/basic-vectorization"],
    "Text Classification": [<BsFillFileEarmarkTextFill />, "/text-classification"],
    "Information Extraction (IE)": [<HiMiniInformationCircle />, "/information-extraction-IE"],
    "Topic Modeling": [<MdOutlineTopic />, "/topic-modeling"],
    "Text Summarization": [<PiTextTFill />, "/text-summarization"],
    "Search and Match": [<LuFileSearch2 />, "/search-match"],
  }), []);

  const PAGE_SLUG_ROUTES = React.useMemo(() => ({
    "retrieval-augmented-llm": "/retrieval-augmented-llm",
    "synergy-augmented-llm": "/synergy-augmented-LLM",
  }), []);

  const createMenu = useCallback((nodes) => {
    if (!Array.isArray(nodes)) return [];

    /* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
    /* Hide retired Ch 1 section 1.2 even if Mongo MenuItems still returns it. */
    const visibleNodes = nodes.filter((node) => !isRetiredCh12Node(node));
    /* Code end. ray using AI Agent. 2026-08-24 */
    
    return visibleNodes.map(node => {
      /* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-19. Code Start */
      const strippedName = stripMenuLabelEmojis(node.name);
      /* Added the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Code Start */
      const displayName = CH1_SECTION_RENUMBER[strippedName] || strippedName;
      const mapping =
        Icons_Routes_Object[displayName] ||
        Icons_Routes_Object[strippedName] ||
        Icons_Routes_Object[node.name] ||
        [];
      /* Code end. ray using AI Agent. 2026-08-24 */
      /* Commenting the following code for 1.2rmv.ray using AI Agent. 2026-08-24. Comment Start */
      // const displayName = stripMenuLabelEmojis(node.name);
      // const mapping = Icons_Routes_Object[node.name] || Icons_Routes_Object[displayName] || [];
      /* Commenting end. ray using AI Agent. 2026-08-24 */
      /* Code end. ray using AI Agent. 2026-06-19 */
      const icon = mapping[0] || <BiSolidFolder />;
      let path = mapping[1];
      if (node.isLeaf) {
        /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-14. Code Start */
        // Duplicate menu positions share pageSlug (content/permissions) but have a unique
        // path slug. Prefer the unique slug so Ch 2 CNN stays under Ch 2 instead of jumping
        // to the Icons_Routes / pageSlug URL used by Ch 1.
        if (node.slug && node.pageSlug && node.slug !== node.pageSlug) {
          path = `/${node.slug}`;
        } else if (!path && node.pageSlug && PAGE_SLUG_ROUTES[node.pageSlug]) {
          path = PAGE_SLUG_ROUTES[node.pageSlug];
        } else if (!path) {
          /* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-25. Code Start */
          path = `/${node.pageSlug || node.slug}`;
          /* Code end. ray using AI Agent. 2026-06-25 */
        }
        /* Code end. ray using AI Agent. 2026-07-14 */
      } else if (!path && node.slug) {
        /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
        // Folder nodes open a simple description page keyed by menu slug.
        /* Added the following code for raymenusstructure.ray using AI Agent. 2026-07-14. Code Start */
        // Security / Admin are container-only: expand/collapse children, never open a description page.
        /* Added the following code for progress_tracking.ray using AI Agent. 22/07/2026. Code Start */
        if (node.slug !== "security" && node.slug !== "admin") {
          path = `/${node.slug}`;
        }
        /* Code end. ray using AI Agent. 22/07/2026 */
        /* Commenting the following code for progress_tracking.ray using AI Agent. 22/07/2026. Comment Start */
        // if (node.slug !== "security") {
        //   path = `/${node.slug}`;
        // }
        /* Commenting end. ray using AI Agent. 22/07/2026 */
        /* Code end. ray using AI Agent. 2026-07-14 */
        /* Code end. ray using AI Agent. 2026-07-10 */
      }
      /* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-24. Code Start */
      if (path && !path.startsWith("/")) {
        path = `/${path}`;
      }
      /* Code end. ray using AI Agent. 2026-06-24 */

      return {
        title: displayName,
        icon: icon,
        path: path,
        slug: node.slug || "",
        submenu: node.children && node.children.length > 0,
        submenuItems: node.children && node.children.length > 0 ? createMenu(node.children) : []
      };
    });
  }, [Icons_Routes_Object, PAGE_SLUG_ROUTES]);

  /* Added the following code for progress_tracking.ray using AI Agent. 22/07/2026. Code Start */
  /* Commenting the following code for FAST.Ray using AI Agent. 24/07/2026. Comment Start */
  // const isAdminUser = localStorage.getItem("isAdmin") === "true";
  /* Commenting end. Ray using AI Agent. 24/07/2026 */
  const canCohort =
    isAdminUser || hasPermission(routePermits, "learning-progress_v");
  const canUnlockRules =
    isAdminUser ||
    hasPermission(routePermits, "unlock-rules_v") ||
    hasPermission(routePermits, "unlock-rules_u");
  /* Code end. ray using AI Agent. 22/07/2026 */

  useEffect(() => {
    const normalized = normalizeTreeNodes(permissions);
    let menus = createMenu(normalized);
    /* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
    // Nest My Learning / Learning Path under Dashboard; Learning Progress for admins too.
    menus = menus.map((item) => {
      const isDashboard =
        item.slug === "dashboard" ||
        item.path === "/home" ||
        titlesMatch(item.title, "Dashboard");
      if (!isDashboard) return item;

      const extras = [];
      /* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
      // Learner hubs: learners always; admins only in view-as / Preview as learner.
      // Routes stay open so admins can still open /my-learning and /learning-path by URL.
      const showLearnerHubs =
        !isAdminUser || learnerPreview || !!viewAs?.userId;
      if (showLearnerHubs) {
        extras.push(
          {
            title: "My Learning",
            icon: <FaBook />,
            path: "/my-learning",
            slug: "my-learning",
            submenu: false,
            submenuItems: [],
          },
          {
            title: "Learning Path",
            icon: <FaBook />,
            path: "/learning-path",
            slug: "learning-path",
            submenu: false,
            submenuItems: [],
          }
        );
      }
      /* Code end. Ray using AI Agent. 27/07/2026 */
      /* Commenting the following code for FAST.Ray using AI Agent. 27/07/2026. Comment Start */
      // const extras = [
      //   {
      //     title: "My Learning",
      //     icon: <FaBook />,
      //     path: "/my-learning",
      //     slug: "my-learning",
      //     submenu: false,
      //     submenuItems: [],
      //   },
      //   {
      //     title: "Learning Path",
      //     icon: <FaBook />,
      //     path: "/learning-path",
      //     slug: "learning-path",
      //     submenu: false,
      //     submenuItems: [],
      //   },
      // ];
      /* Commenting end. Ray using AI Agent. 27/07/2026 */
      /* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */
      // Admin: Learning Progress lives under Dashboard (not Admin folder).
      /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
      // Hide while Preview as myself OR View as student (learner-shaped nav).
      if (canCohort && !learnerPreview && !viewAs?.userId) {
      /* Code end. ray using AI Agent. 24/07/2026 */
      /* Commenting the following code for progress_tracking.ray using AI Agent. 24/07/2026. Comment Start */
      // if (canCohort && !learnerPreview) {
      /* Commenting end. ray using AI Agent. 24/07/2026 */
        extras.push({
          title: "Learning Progress",
          icon: <FaBook />,
          path: "/learning-progress",
          slug: "learning-progress",
          submenu: false,
          submenuItems: [],
        });
      }
      /* Code end. Ray using AI Agent. 24/07/2026 */
      /* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
      // Admin: Unlock Rules under Dashboard (same placement as Learning Progress).
      if (canUnlockRules && !learnerPreview && !viewAs?.userId) {
        extras.push({
          /* Added the following code for video.ray using AI Agent. 29/07/2026. Code Start */
          title: "Site Settings",
          /* Code end. ray using AI Agent. 29/07/2026 */
          /* Commenting the following code for video.ray using AI Agent. 29/07/2026. Comment Start */
          // title: "Unlock Rules",
          /* Commenting end. ray using AI Agent. 29/07/2026 */
          icon: <FaTasks />,
          path: "/unlock-rules",
          slug: "unlock-rules",
          submenu: false,
          submenuItems: [],
        });
      }
      /* Code end. Ray using AI Agent. 27/07/2026 */
      /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
      if ((isAdminUser || hasPermission(routePermits, "users_v")) && !learnerPreview && !viewAs?.userId) {
        extras.push({
          title: "Organization Admin",
          icon: <FaUsers />,
          path: "/tenant-admin",
          slug: "tenant-admin",
          submenu: false,
          submenuItems: [],
        });
      }
      /* Added the following code for platform_tenants.ray using AI Agent. 10/10/2026. Code Start */
      if (isPlatformAdmin && !learnerPreview && !viewAs?.userId) {
        extras.push({
          title: "Platform Tenants",
          icon: <FaBuilding />,
          path: "/platform-tenants",
          slug: "platform-tenants",
          submenu: false,
          submenuItems: [],
        });
      }
      /* Code end. ray using AI Agent. 10/10/2026 */
      /* Code end. ray using AI Agent. Oct 9, 2026 */
      const existing = item.submenuItems || [];
      const withoutDupes = existing.filter(
        (child) =>
          child.path !== "/my-learning" &&
          child.path !== "/learning-path" &&
          child.path !== "/learning-progress" &&
          child.path !== "/unlock-rules" &&
          child.path !== "/tenant-admin" &&
          child.path !== "/platform-tenants"
      );
      return {
        ...item,
        submenu: true,
        submenuItems: [...withoutDupes, ...extras],
      };
    });
    /* Code end. ray using AI Agent. 21/07/2026 */

    /* Added the following code for progress_tracking.ray using AI Agent. 22/07/2026. Code Start */
    // Nest Unlock Rules under Admin (Learning Progress moved to Dashboard).
    const adminExtras = [];
    /* Commenting the following code for FAST.Ray using AI Agent. 24/07/2026. Comment Start */
    // if (canCohort) {
    //   adminExtras.push({
    //     title: "Learning Progress",
    //     icon: <FaBook />,
    //     path: "/learning-progress",
    //     slug: "learning-progress",
    //     submenu: false,
    //     submenuItems: [],
    //   });
    // }
    /* Commenting end. Ray using AI Agent. 24/07/2026 */
    /* Commenting the following code for FAST.Ray using AI Agent. 27/07/2026. Comment Start */
    // Unlock Rules moved under Dashboard.
    // if (canUnlockRules) {
    //   adminExtras.push({
    //     title: "Unlock Rules",
    //     icon: <FaTasks />,
    //     path: "/unlock-rules",
    //     slug: "unlock-rules",
    //     submenu: false,
    //     submenuItems: [],
    //   });
    // }
    /* Commenting end. Ray using AI Agent. 27/07/2026 */

    /* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
    // Strip progress tools from Admin folder — they live under Dashboard now.
    menus = menus.map((item) => {
      const isAdminFolder =
        item.slug === "admin" || titlesMatch(item.title, "Admin");
      if (!isAdminFolder) return item;
      const existing = item.submenuItems || [];
      return {
        ...item,
        submenuItems: existing.filter(
          (child) =>
            child.path !== "/learning-progress" &&
            child.path !== "/unlock-rules"
        ),
      };
    });
    /* Code end. Ray using AI Agent. 27/07/2026 */

    if (adminExtras.length > 0) {
      let adminFound = false;
      menus = menus.map((item) => {
        const isAdminFolder =
          item.slug === "admin" || titlesMatch(item.title, "Admin");
        if (!isAdminFolder) return item;
        adminFound = true;
        const existing = item.submenuItems || [];
        const withoutDupes = existing.filter(
          (child) =>
            child.path !== "/learning-progress" &&
            child.path !== "/unlock-rules"
        );
        return {
          ...item,
          submenu: true,
          submenuItems: [...withoutDupes, ...adminExtras],
        };
      });

      if (!adminFound) {
        menus = [
          ...menus,
          {
            title: "Admin",
            icon: <FaTasks />,
            path: "",
            slug: "admin",
            submenu: true,
            submenuItems: adminExtras,
          },
        ];
      }
    }
    /* Code end. ray using AI Agent. 22/07/2026 */
    /* Added the following code for deployfix.Ray using AI Agent. 09/10/2026. Code Start */
    // Platform admins manage users even when their roles lack users_v (the backend nav tree omits it).
    if (localStorage.getItem("isPlatformAdmin") === "true") {
      const usersItem = {
        title: "Users",
        icon: <FaUsers />,
        path: "/users",
        slug: "users",
        submenu: false,
        submenuItems: [],
      };
      let securityFound = false;
      menus = menus.map((item) => {
        const isSecurityFolder =
          item.slug === "security" || titlesMatch(item.title, "Security");
        if (!isSecurityFolder) return item;
        securityFound = true;
        const existing = item.submenuItems || [];
        if (existing.some((child) => child.path === "/users")) return item;
        return { ...item, submenu: true, submenuItems: [usersItem, ...existing] };
      });
      if (!securityFound) {
        const securityFolder = {
          title: "Security",
          icon: <MdSecurity />,
          path: "",
          slug: "security",
          submenu: true,
          submenuItems: [usersItem],
        };
        const dashboardIndex = menus.findIndex(
          (item) => item.slug === "dashboard" || titlesMatch(item.title, "Dashboard")
        );
        menus = [
          ...menus.slice(0, dashboardIndex + 1),
          securityFolder,
          ...menus.slice(dashboardIndex + 1),
        ];
      }
    }
    /* Code end. Ray using AI Agent. 09/10/2026 */
    /* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */
    // Hide Admin / Security while Preview as learner is on (learner-shaped nav).
    /* Added the following code for progress_tracking.ray using AI Agent. 24/07/2026. Code Start */
    // Same learner-shaped nav when Viewing as a specific student.
    if (learnerPreview || viewAs?.userId) {
    /* Code end. ray using AI Agent. 24/07/2026 */
    /* Commenting the following code for progress_tracking.ray using AI Agent. 24/07/2026. Comment Start */
    // if (learnerPreview) {
    /* Commenting end. ray using AI Agent. 24/07/2026 */
      menus = menus.filter(
        (item) =>
          !(
            item.slug === "admin" ||
            item.slug === "security" ||
            titlesMatch(item.title, "Admin") ||
            titlesMatch(item.title, "Security")
          )
      );
    }
    /* Code end. Ray using AI Agent. 24/07/2026 */
    setMenus(menus);
  /* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
  }, [permissions, createMenu, canCohort, canUnlockRules, learnerPreview, viewAs?.userId, isAdminUser]);
  /* Code end. Ray using AI Agent. 27/07/2026 */
  /* Commenting the following code for FAST.Ray using AI Agent. 27/07/2026. Comment Start */
  // }, [permissions, createMenu, canCohort, canUnlockRules, learnerPreview, viewAs?.userId]);
  /* Commenting end. Ray using AI Agent. 27/07/2026 */

  const [open, setOpen] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );
  const [openStates, setOpenStates] = useState({});
  const [selectedPage, setSelectedPage] = useState("");

  /* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
  // On mobile, collapse the sidebar after route changes so content is readable.
  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth < 768) {
      setOpen(false);
    }
  }, [location.pathname]);
  /* Code end. ray using AI Agent. 21/07/2026 */

  /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-09. Code Start */
  const lastAutoExpandedPathRef = React.useRef(null);

  useEffect(() => {
    if (!Menus.length) return;

    /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
    // Only auto-expand on route changes so a second click can collapse the folder.
    const shouldAutoExpand = lastAutoExpandedPathRef.current !== location.pathname;
    /* Added the following code for caproj.ray using AI Agent. 14/09/2026. Code Start */
    // Map short Capstone routes (/capstone-design, /your-capstone-project, …)
    // to the ch-* menu-slug paths stored on sidebar items.
    const pathForMenu = (() => {
      /* Added the following code for caps.ray using AI Agent. 2026-09-24. Code Start */
      if (
        location.pathname === "/your-capstone-project" ||
        /* Commenting the following code for compileroverride.ray using AI Agent. Sep 27, 2026. Comment Start */
        // location.pathname === "/capstone-hub" ||
        /* Commenting end. ray using AI Agent. Sep 27, 2026 */
        String(location.pathname).startsWith("/capstone-workshop/")
      ) {
        return "/ch-7-real-world-applications-78-your-capstone-project";
      }
      /* Code end. ray using AI Agent. 2026-09-24 */
      /* Commenting the following code for caps.ray using AI Agent. 2026-09-24. Comment Start */
      // if (location.pathname === "/your-capstone-project") {
      //   return "/ch-7-real-world-applications-78-your-capstone-project";
      // }
      /* Commenting end. ray using AI Agent. 2026-09-24 */
      const resolved = toNavigableProgressPath(location.pathname);
      return resolved || location.pathname;
    })();
    /* Code end. ray using AI Agent. 14/09/2026 */
    if (shouldAutoExpand) {
      lastAutoExpandedPathRef.current = location.pathname;

      /* Added the following code for caproj.ray using AI Agent. 14/09/2026. Code Start */
      const located =
        findMenuItemByPath(Menus, pathForMenu) ||
        findMenuItemByPath(Menus, location.pathname);
      /* Code end. ray using AI Agent. 14/09/2026 */
      /* Commenting the following code for caproj.ray using AI Agent. 14/09/2026. Comment Start */
      // const located = findMenuItemByPath(Menus, location.pathname);
      /* Commenting end. ray using AI Agent. 14/09/2026 */
      if (located) {
        setOpenStates((prev) => ({
          ...prev,
          ...getAncestorPathIds(located.pathId),
          [located.pathId]: true,
        }));
        setSelectedPage(located.item.title);
      }

      const chapterDefault =
        getChapterDefaultConfigForPath(location.pathname) ||
        getChapterDefaultConfigForPath(pathForMenu);
      if (chapterDefault) {
        const [chapterPath, config] = chapterDefault;
        const expandStates = buildChapterExpandStates(Menus, chapterPath, config.sectionTitles);
        setOpenStates((prev) => ({ ...prev, ...expandStates }));

        const highlightTitle =
          config.highlightByPath?.[location.pathname] ||
          config.highlightByPath?.[pathForMenu];
        if (highlightTitle) setSelectedPage(highlightTitle);
      }
    } else {
      const chapterDefault =
        getChapterDefaultConfigForPath(location.pathname) ||
        getChapterDefaultConfigForPath(pathForMenu);
      if (chapterDefault) {
        const highlightTitle =
          chapterDefault[1].highlightByPath?.[location.pathname] ||
          chapterDefault[1].highlightByPath?.[pathForMenu];
        if (highlightTitle) setSelectedPage(highlightTitle);
      }
    }
    /* Code end. ray using AI Agent. 2026-07-10 */
  }, [location.pathname, Menus]);
  /* Code end. ray using AI Agent. 2026-07-09 */

  const handleopen = () => {
    setOpen(!open);
    if (!open) {
      setOpenStates({});
    }
  };

  /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-10. Code Start */
  const toggleSubmenu = (pathId) => {
    setOpenStates((prev) => ({
      ...prev,
      [pathId]: !prev[pathId],
    }));
  };
  /* Code end. ray using AI Agent. 2026-07-10 */

  /* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */
  // Keep expand preference on Resside so MenuItemComponent remounts do not reset it.
  const [progressRailExpanded, setProgressRailExpanded] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= 768 : true
  );

  // YOUR PROGRESS lives under Dashboard again (collapsible via SidebarProgress).
  const renderDashboardProgress = () => (
    <SidebarProgress
      progress={progress}
      onResume={onResume}
      progressStatus={progressStatus}
      progressError={progressError}
      onRetry={retryProgress}
      railExpanded={progressRailExpanded}
      onRailExpandedChange={setProgressRailExpanded}
    />
  );
  /* Code end. ray using AI Agent. 28/07/2026 */

  /* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */
  // Auto-expand Dashboard once so the nested progress rail is discoverable.
  const didAutoExpandDashboard = useRef(false);
  useEffect(() => {
    if (!showProgressRail) {
      didAutoExpandDashboard.current = false;
      return;
    }
    if (didAutoExpandDashboard.current || !Menus.length) return;
    const dashPathId = findMenuPathIdByTitle(Menus, "Dashboard");
    if (!dashPathId) return;
    didAutoExpandDashboard.current = true;
    setOpenStates((prev) => ({
      ...prev,
      ...getAncestorPathIds(dashPathId),
      [dashPathId]: true,
    }));
  }, [showProgressRail, Menus]);
  /* Code end. ray using AI Agent. 28/07/2026 */

  const MenuItemComponent = ({ item, pathId, level = 0 }) => {
    const isOpen = !!openStates[pathId];
    const isSelected = item.title === selectedPage;
    const linkPath = item.path || "#";
    /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
    const chapterRef = getChapterRef(item);
    const planLocked = Boolean(
      chapterRef &&
      activeTenant?.entitlements?.chapterRefs?.length > 0 &&
      !activeTenant.entitlements.chapterRefs.includes(chapterRef) &&
      !isPlatformAdmin
    );
    /* Code end. ray using AI Agent. Oct 9, 2026 */
    /* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
    const locked = planLocked || isPathLocked(item.path);
    /* Code end. ray using AI Agent. 21/07/2026 */
    const itemStyle = {
      paddingLeft: `${level * 12 + 8}px`,
      backgroundColor: isSelected && !locked ? '#0891b2' : '',
      color: planLocked ? '#b45309' : locked ? '#9ca3af' : isSelected ? 'white' : '#044661',
      opacity: locked ? 0.75 : 1,
      cursor: locked ? 'not-allowed' : 'pointer',
    };
    const bgClass = isSelected || locked ? '' : 'hover:bg-gray-200';

    return (
      <div>
        <Link
          to={locked ? "#" : linkPath}
          state={item.path && !locked ? { pageName: item.title } : undefined}
          className={`text-base flex items-center gap-x-4 cursor-pointer rounded-md mt-1 p-2 ${bgClass}`}
          style={itemStyle}
          /* Added the following code for FAST.Ray using AI Agent. 23/07/2026. Code Start */
          onMouseEnter={() => {
            // Warm JS chunk + path cache before click so hub/path feel instant.
            if (item.path === "/my-learning") {
              import("./MyLearning").catch(() => {});
              fetchLearningPath({ hub: true }).catch(() => {});
            } else if (item.path === "/learning-path") {
              import("./LearningPath").catch(() => {});
              fetchLearningPath().catch(() => {});
            }
          }}
          /* Code end. Ray using AI Agent. 23/07/2026 */
          onClick={(e) => {
            const hasNavPath = item.path && item.path !== "#";
            if (!hasNavPath) e.preventDefault();

            /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
            if (planLocked && hasNavPath) {
              e.preventDefault();
              toast.error(
                `Chapter ${chapterRef.toUpperCase()} is not included in ${activeTenant?.name || "your organization"}'s subscription plan. Contact your administrator.`,
                { icon: "🔒", duration: 4000 }
              );
              return;
            }
            /* Code end. ray using AI Agent. Oct 9, 2026 */

            /* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
            if (locked && hasNavPath) {
              e.preventDefault();
              /* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */
              const missing = formatMissingChecklist(lockMap?.missingChecklist);
              toast.error(
                lockMap?.lockMessage ||
                  (missing
                    ? `Locked — finish first: ${missing}`
                    : "Locked — finish the previous module checklist first.")
              );
              /* Code end. ray using AI Agent. 21/07/2026 */
              if (lockMap?.resumePath) {
                /* Added the following code for smarterresume.ray using AI Agent. 22/07/2026. Code Start */
                navigate(lockMap.resumePath, {
                  state: buildResumeNavState({ lockMap }),
                });
                /* Code end. ray using AI Agent. 22/07/2026 */
              }
              return;
            }
            /* Code end. ray using AI Agent. 21/07/2026 */

            /* Added the following code for ray_menuStructure.ray. ray using AI Agent. 2026-07-09. Code Start */
            const chapterConfig = item.path ? CHAPTER_DEFAULT_SECTIONS[item.path] : null;
            const willNavigate = hasNavPath && location.pathname !== item.path;

            if (item.submenu) {
              if (willNavigate) {
                // Opening a folder page: expand this node and ancestors.
                const expandStates = {
                  ...getAncestorPathIds(pathId),
                  [pathId]: true,
                };
                if (chapterConfig) {
                  Object.assign(
                    expandStates,
                    buildChapterExpandStates(Menus, item.path, chapterConfig.sectionTitles)
                  );
                }
                setOpenStates((prev) => ({ ...prev, ...expandStates }));
              } else {
                // Already on this page (or no nav): toggle open/closed.
                toggleSubmenu(pathId);
              }
            }
            /* Code end. ray using AI Agent. 2026-07-09 */

            if (hasNavPath) {
              const highlightTitle =
                chapterConfig?.highlightByPath?.[item.path] || item.title;
              setSelectedPage(highlightTitle);
              if (willNavigate) {
                e.preventDefault();
                navigate(item.path, { state: { pageName: item.title } });
              }
            }
          }}
        >
          {item.icon}{" "}
          <span className="flex-1">
            {item.title}
            {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
            {planLocked ? (
              <span className="ml-1 text-[9px] font-bold uppercase tracking-wider bg-amber-100 text-amber-800 border border-amber-300 px-1.5 py-0.5 rounded shadow-xs">
                🔒 Plan Lock
              </span>
            ) : locked ? (
              <span className="ml-1 text-[10px] font-semibold uppercase tracking-wide">
                Locked
              </span>
            ) : null}
            {/* Code end. ray using AI Agent. Oct 9, 2026 */}
          </span>
          {item.submenu && (
            <BsChevronDown className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
          )}
        </Link>
        {item.submenu && isOpen && open && (
          <ul className="ml-2">
            {item.submenuItems.map((child, idx) => (
              <MenuItemComponent 
                key={`${pathId}-${idx}`} 
                item={child} 
                pathId={`${pathId}-${idx}`} 
                level={level + 1} 
              />
            ))}
            {/* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */}
            {isDashboardMenuItem(item) && showProgressRail ? (
              <li className="list-none pb-2">{renderDashboardProgress()}</li>
            ) : null}
            {/* Code end. ray using AI Agent. 28/07/2026 */}
          </ul>
        )}
      </div>
    );
  };

  /* Added the following code for raymenusstructure.ray using AI Agent. 2026-07-14. Code Start */
  // Use h-full (not h-screen) so the sidebar fits under the header and can
  // scroll to later chapters when many folders are expanded.
  /* Commenting the following code for progress_tracking.ray using AI Agent. 22/07/2026. Comment Start */
  // Top-level Learning Progress / Unlock Rules strip — moved under Admin menu.
  // const progressNav = [
  //   { title: "Learning Progress", path: "/learning-progress", show: canCohort },
  //   { title: "Unlock rules", path: "/unlock-rules", show: canUnlockRules },
  // ].filter((item) => item.show);
  /* Commenting end. ray using AI Agent. 22/07/2026 */
  /* Code end. ray using AI Agent. 21/07/2026 */
  return (
    <div className={`flex h-full min-h-0 overflow-y-auto duration-500 border-r border-gray-200 transition-all ${open ? (showProgressRail ? "w-80" : "w-72") : "w-0"}`}>
      {/* Commenting the following code for logo.ray using AI Agent. 19/08/2026. Comment Start */}
      {/* <img
        src={hambuger}
        className={`text-black text-2xl absolute top-5 left-5 z-50 cursor-pointer ${open && "rotate-180"}`}
        onClick={handleopen}
        alt="hamburger"
      /> */}
      {/* Commenting end. ray using AI Agent. 19/08/2026 */}
      {/* Added the following code for logo.ray using AI Agent. 19/08/2026. Code Start */}
      {/* Match header logo/search height (h-10); top-3 centers it in the h-16 header. */}
      <img
        src={hambuger}
        className={`h-9 w-9 object-contain absolute top-3 left-5 z-50 cursor-pointer ${open && "rotate-180"}`}
        onClick={handleopen}
        alt="hamburger"
      />
      {/* Code end. ray using AI Agent. 19/08/2026 */}
      <div className={`pt-16 bg-white relative w-full`}>
        {/* Added the following code for progress_tracking.ray using AI Agent. 22/07/2026. Code Start */}
        {viewAs?.userId ? (
          <div className="mx-2 mb-2 rounded-md border border-amber-300 bg-amber-50 px-2 py-2 text-[11px] text-amber-900">
            <p className="font-semibold">Viewing as {viewAs.name || viewAs.email}</p>
            <p className="opacity-90">Read-only locks & checklist (no writes)</p>
            <button
              type="button"
              className="mt-1 underline font-semibold"
              onClick={exitViewAs}
            >
              Exit view-as
            </button>
          </div>
        ) : null}
        {/* Added the following code for FAST.Ray using AI Agent. 24/07/2026. Code Start */}
        {learnerPreview && !viewAs?.userId ? (
          <div className="mx-2 mb-2 rounded-md border border-cyan-300 bg-cyan-50 px-2 py-2 text-[11px] text-cyan-950">
            <p className="font-semibold">Preview as learner</p>
            <p className="opacity-90">
              YOUR PROGRESS and locks apply to your account
            </p>
            <button
              type="button"
              className="mt-1 underline font-semibold"
              onClick={exitLearnerPreview}
            >
              Exit preview
            </button>
          </div>
        ) : null}
        {/* Code end. Ray using AI Agent. 24/07/2026 */}
        {/* Code end. ray using AI Agent. 22/07/2026 */}
        {/* Commenting the following code for progress.ray using AI Agent. 28/07/2026. Comment Start */}
        {/* Pinned strip removed — YOUR PROGRESS is a collapsible item under Dashboard again. */}
        {/* {showProgressRail ? (
          <div className="px-2 pb-1">
            <SidebarProgress ... />
          </div>
        ) : null} */}
        {/* Commenting end. ray using AI Agent. 28/07/2026 */}
        {loading ? (
          <SidebarSkeleton />
        ) : (
          <>
            {/* Commenting the following code for progress_tracking.ray using AI Agent. 22/07/2026. Comment Start */}
            {/* Top strip removed — Learning Progress / Unlock Rules now live under Admin. */}
            {/* {progressNav.length > 0 ? ( ... ) : null} */}
            {/* Commenting end. ray using AI Agent. 22/07/2026 */}
            <ul className="pt-2 w-full px-2">
              {Menus.map((menu, index) => (
                <MenuItemComponent key={index} item={menu} pathId={`${index}`} level={0} />
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
  /* Code end. ray using AI Agent. 2026-07-14 */
};

export default Resside;
